import { render } from "./carousel.vue?vue&type=template&id=62a43f38&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=62a43f38&lang=scss&scoped=true"
import "./carousel.vue?vue&type=style&index=1&id=62a43f38&lang=scss"
script.render = render
script.__scopeId = "data-v-62a43f38"

export default script